//import SettingsIcon from '@mui/icons-material/Settings';
import CallMadeIcon from '@mui/icons-material/CallMade';
import HelpIcon from '@mui/icons-material/Help';

import DropdownMenu from './DropdownMenu';
import EditIcon from '@mui/icons-material/Edit';
import LaunchIcon from "@mui/icons-material/Launch";
import {Link} from 'react-router-dom';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MuiLink from '@mui/material/Link';
import React from 'react';
import { ReactComponent as SettingsIcon } from "../../Icons/settings.svg";
import { ReactComponent as CalendarFillIcon } from "../../Icons/Calendar-fill.svg";
import { ReactComponent as HouseDoorIcon } from "../../Icons/House-door.svg";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    menuItem: {
        ...theme.palette.background.menu.inactive,
        "&:hover": {
            ...theme.palette.background.menu.hover,
            textDecoration: 'none'
        },
        "&:active": {
            ...theme.palette.background.menu.active,
        },
    },
    helpItem: {
        [theme.breakpoints.up('md')]: {
            display: "none",
        },
    },
}));

export default function SettingsMenu({ onClose, uid, open, buttonRef, popperPlacement }) {
    return (
        <DropdownMenu uid={uid} onClose={onClose} open={open} buttonRef={buttonRef} popperPlacement={popperPlacement}>
            <MenuItems onClose={onClose} />
        </DropdownMenu>
    );
}

function MenuItems({ onClose }) {
    const classes = useStyles();

    const primaryTypographyProps = {
        variant: "subtitle1",
    };

    return (
        <>
            <MenuItem onClick={onClose} className={classes.menuItem} component={Link} to="/notes" 
            color="inherit" tabIndex={0}>
                <ListItemText primary="My Notes" primaryTypographyProps={primaryTypographyProps} />
                <EditIcon edge="end" />
            </MenuItem>
            <MenuItem onClick={onClose} className={classes.menuItem} component={MuiLink} href={process.env.REACT_APP_VOTING_SETTINGS_URL} 
            color="inherit" tabIndex={0}>
                <ListItemText primary="Settings" primaryTypographyProps={primaryTypographyProps} />
                <SettingsIcon edge="end" />
            </MenuItem>
            <MenuItem onClick={onClose} className={classes.menuItem} component={MuiLink} href={process.env.REACT_APP_EVENTS_URL} target="_blank" 
            color="inherit" tabIndex={0}>
                <ListItemText primary="BAFTA Events" primaryTypographyProps={primaryTypographyProps} />
                <CalendarFillIcon edge="end" />
            </MenuItem>
            <MenuItem onClick={onClose} className={classes.menuItem} component={MuiLink} href={process.env.REACT_APP_VOTING_URL} target="_blank"
             color="inherit" tabIndex={0}>
                <ListItemText primary="Vote" primaryTypographyProps={primaryTypographyProps} />
                <LaunchIcon edge="end" />
            </MenuItem>
            <MenuItem onClick={onClose} className={classes.menuItem} component={MuiLink} href={process.env.REACT_APP_SSO_URL} target="_blank"
             color="inherit" tabIndex={0}>
                <ListItemText primary="My Bafta" primaryTypographyProps={primaryTypographyProps} />
                <HouseDoorIcon edge="end" />
            </MenuItem>
            <MenuItem onClick={onClose} className={[classes.menuItem, classes.helpItem].join(' ')} component={MuiLink} href={process.env.REACT_APP_HELPSITE_URI} target="_blank"
             color="inherit" tabIndex={0}>
                <ListItemText primary="Help" primaryTypographyProps={primaryTypographyProps} />
                <HelpIcon edge="end" />
            </MenuItem>
            <MenuItem onClick={onClose} className={classes.menuItem} component={MuiLink} href={process.env.REACT_APP_LOGOUT_URL}
            color="inherit" tabIndex={0}>
                <ListItemText primary="Log out" primaryTypographyProps={primaryTypographyProps} />
                <CallMadeIcon edge="end" />
            </MenuItem>
        </>
    );
}